module.exports = __webpack_public_path__ + "static/media/codeTurtleRace.6346f176.png";